import React, { Component } from "react";
import { espotAPI } from "../../../../public/constants/constants";
import apiManager from "../../../utils/apiManager";
import "../../../../public/styles/HomeInteriors/LocateUs/StoreText.scss";

export default class StoreTextSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      espotName: "GI_Interiors_LocateUs_textSection",
      text: "",
      title: "",
    };
  }

  getEspotData() {
    apiManager
      .get(espotAPI + this.state.espotName)
      .then(response => {
        const { data } = response || {};
        this.setState({
          text: data.data && data.data.text,
          title: data.data && data.data.title,
        });
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false,
        });
      });
  }

  componentDidMount() {
    this.getEspotData();
  }

  render() {
    return (
      <div className="text-container">
        <div className="text-wrapper">
          <h3>{this.state.title}</h3>
          <div>{this.state.text}</div>
        </div>
      </div>
    );
  }
}
